import { useCallback, useEffect, useRef, useState } from "react";
import { IComboBox, IComboBoxOption } from "@fluentui/react";
import { Ifilter } from "../../interfaces/IFilter";
import EmpresaService from "../../services/empresaService";

interface UbicacionProps {
    isOpen: boolean;
    equipoAuxiliar?: boolean
}

const UseComboTransporte = (isOpen: boolean) => {
    const controllerRef = useRef<AbortController>(new AbortController());
    const [filter, setFilter] = useState<Ifilter>({
        skip: 0,
        take: 20,
        search: ""
    });
    const [dataCombotransporte, setDataCombotransporte] = useState<IComboBoxOption[]>([]);
    const comboBoxRefTransporte = useRef<IComboBox>(null);

    const onClickComboTransporte = () => comboBoxRefTransporte.current?.focus(true);

    const _openOption = useCallback(
        () => comboBoxRefTransporte.current?.focus(true),
        []
    );

    const _onkeyUpSearchTransporte = (event: React.KeyboardEvent<IComboBox>) => {
        if (event.code === "Escape") {
            comboBoxRefTransporte.current?.focus(false);
            setFilter({
                skip: 0,
                take: 20,
                search: ""
            });
        } else {
            _openOption();
            let { value } = event?.target as HTMLInputElement;
            setFilter({ ...filter, search: value });
        }
    };

    const listarCombo = () => {
        controllerRef.current.abort();
        const newController = new AbortController();
        controllerRef.current = newController;
        EmpresaService.allTitularMMG(filter, newController).then((res) => {
            if (res.status === 200) {
                setDataCombotransporte(res.data);
            }
        });
    };

    useEffect(() => {
        if (isOpen) {
            listarCombo();
        }
    }, [isOpen, filter]);

    return {
        dataCombotransporte,
        onClickComboTransporte,
        _onkeyUpSearchTransporte,
        comboBoxRefTransporte,
        filter,
        setFilter
    };
}

export { UseComboTransporte }
